module.exports = __webpack_public_path__ + "static/media/userDatabase.1be26d3f.svg";